import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './context/authContext';
import LoadingComponent from "assets/theme/functions/loadingAnimation";

const ProtectedRoute = ({ children }) => {
  const [state, setState] = useState({ loading: true, isAuth: false, hasConsent: false });
  const { isAuthenticated, hasAcceptedPrivacyConsent } = useAuth();

  useEffect(() => {
    const checkAuth = async () => {
      const auth = await isAuthenticated();
      const hasConsent = auth ? hasAcceptedPrivacyConsent() : false;
      setState({ loading: false, isAuth: auth, hasConsent });
    };

    checkAuth();

  }, [isAuthenticated, hasAcceptedPrivacyConsent]);

  if (state.loading) {
    return <LoadingComponent />
  }

  if (!state.isAuth) {
    return <Navigate to="/login" replace />;
  }

  if (!state.hasConsent) {
    return <Navigate to="/consentimento-privacidade" replace />;
  }

  return children;
};

export default ProtectedRoute;